import React, {PropsWithChildren} from 'react';
import {Typography} from '@mui/material';
import {ShowIfDebugWrapper} from '../../contexts/DebugProvider';

export const AutoFieldDebug: React.FC<PropsWithChildren> = ({children}) => {
  return (
    <ShowIfDebugWrapper>
      <Typography color="#AAAAAA" fontSize={12}>
        {children}
      </Typography>
    </ShowIfDebugWrapper>
  );
};
